import Translate from './Translate'
import Vue from 'vue'

Vue.prototype.$t = function(phrase) {
  return this.$store.getters.localePhrase(phrase)
}

Vue.component('T', Translate)